const keys = new WeakMap()
let repeatId = 0

export function getKey(item) {
    if (Array.isArray(item) && item[0]) return getKey(item[0])
    if (item?.id) return item.id
    if (item?._id) return item._id
    if (!!item && typeof item === "object") {
        const key = keys.get(item) ?? repeatId++
        keys.set(item, key)
        return key
    }
    return item
}
